<div class="filter-container">
  <p-header>
    <div class="card-header">
      <h3>Account Filters</h3>
    </div>
  </p-header>
  <form [formGroup]="filterForm">
    <div class="filter-actions top-actions">
      <div class="left-actions">
        <button
          pButton
          type="button"
          label="Add"
          class="p-button-info"
          (click)="addFilterRow()">
        </button>
        <button
          pButton
          type="button"
          label="Clear All"
          class="p-button-primary"
          (click)="clearFilters()">
        </button>
        <span [pTooltip]="getDisabledToolTip()" tooltipPosition="right">
          <button
            *ngIf="filterRows.length !== 0"
            pButton
            type="button"
            label="Preview Accounts"
            class="p-button-primary"
            [disabled]="!hasValidFilters()"
            (click)="previewAccounts()">
          </button>
        </span>
      </div>
    </div>
    <div class="filter-header">
      <div class="property-header">Property</div>
      <div class="value-header">Value</div>
      <div class="action-header"></div>
    </div>
    <div formArrayName="filterRows" class="filter-rows">
      <!-- Default message when no filters are present -->
      <div *ngIf="filterRows.length === 0" class="no-filters-message">
        <p>Click 'Add' to add filters</p>
      </div>
      <div *ngFor="let row of filterRows.controls; let i = index" [formGroupName]="i" class="filter-row">
        <div class="property-column">
          <p-dropdown
            [options]="propertyOptions"
            formControlName="property"
            optionLabel="label"
            optionValue="value"
            [style]="{width: '100%'}"
            (onChange)="onPropertyChange(i, $event.value)">
          </p-dropdown>
        </div>
        <div class="value-column">
          <!-- Dynamic input based on selected property -->
          <ng-container [ngSwitch]="row.value.property">
            <ng-container>
              @if (row.value.property === 'Account') {
                <p-multiSelect
                  [options]="accountNameOptions"
                  formControlName="values"
                  placeholder="Select MPOP Accounts"
                  display="chip"
                  [maxSelectedLabels]="1000"
                  [filter]="true"
                  filterBy="label,value"
                  [filterFields]="['label','value']"
                  [resetFilterOnHide]="true"
                  [style]="{ width: '100%' }"
                  optionLabel="label">
                </p-multiSelect>
              } @else if (row.value.property === 'OEM Program') {
                <p-multiSelect
                  [options]="oemProgramOptions"
                  formControlName="values"
                  placeholder="Select OEMs"
                  display="chip"
                  [maxSelectedLabels]="1000"
                  [style]="{ width: '100%' }"
                  optionLabel="label">
                </p-multiSelect>
              } @else if (row.value.property === 'Region Name') {
                <p-multiSelect
                  [options]="regionOptions"
                  formControlName="values"
                  placeholder="Select Regions"
                  display="chip"
                  [maxSelectedLabels]="1000"
                  [style]="{ width: '100%' }"
                  optionLabel="label">
                </p-multiSelect>
              } @else if (row.value.property === 'Account Make') {
                <p-multiSelect
                  [options]="makeOptions"
                  formControlName="values"
                  placeholder="Select Makes"
                  display="chip"
                  [maxSelectedLabels]="1000"
                  [style]="{ width: '100%' }"
                  optionLabel="label">
                </p-multiSelect>
              }
            </ng-container>
          </ng-container>
        </div>
        <div class="action-column">
          <button
            pButton
            type="button"
            icon="pi pi-trash"
            class="p-button-rounded p-button-danger p-button-text"
            (click)="removeFilterRow(i)">
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
